module.exports = __webpack_public_path__ + "img/word.7d29ec84.svg";